export const UPDATE_HEALTH_INS_DETAIL = 'UPDATE_HEALTH_INS_DETAIL';

export const updateHealthInsDetail = (payload) => {
    return {
        type: UPDATE_HEALTH_INS_DETAIL,
        payload
    };
}
